import React from 'react';
import { TextStyle } from '@superops/ui-design-system';
import { FormattedMessage } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';

const AccessDenied = ({
  small = false,
  iconSize = 'xxxl',
  fullHeight = false
}) => {
  return (
    <div
      className={`flex-center fcol full-width ${
        small || fullHeight ? 'full-height' : 'ch-80'
      }`}
    >
      {!small && (
        <>
          <SVGIcon name="AccessDenied" size={iconSize} />
        </>
      )}
      <TextStyle weight="Medium">
        <FormattedMessage id="app.widget.accessDenied" />
      </TextStyle>
    </div>
  );
};

export default AccessDenied;
